module.exports = __webpack_public_path__ + "static/favicon.aaf48f6a.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = 340
// module chunks = 213534597649335